import moment from 'moment';
import { SHORT_DATE_TIME_FORMAT } from './date';

export const formatDateToLocalTimeZone = (
  date: string | undefined,
  format: string = SHORT_DATE_TIME_FORMAT,
): string | undefined => {
  if (!date) return undefined;
  const utcFormat = moment.utc(date);

  return moment(utcFormat).local().format(format);
};

export const formatDateToUTC = (
  date: string | undefined,
  format: string = SHORT_DATE_TIME_FORMAT,
): string | undefined => {
  if (!date) return undefined;
  const utcFormat = moment.utc(date);

  return moment(utcFormat).format(format);
};

/**
 * Computes the difference of date and time from current local time.
 *
 * @param {string} date
 * UTC from the server to be compared to local tine
 *
 * @returns {Object}
 */
export const diffToLocalTimeZone = (
  date: string,
): {
  years: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  text: string;
} => {
  const localDate = moment(date).local();

  const diffInYears = moment().diff(localDate, 'years');
  const diffInDays = moment().diff(localDate, 'days');
  const diffInHours = moment().diff(localDate, 'hours');
  const diffInMinutes = moment().diff(localDate, 'minutes');
  const diffInSeconds = moment().diff(localDate, 'seconds');
  let formattedText = '';

  if (diffInYears > 0) {
    formattedText = `${diffInYears} year${diffInYears > 1 ? 's' : ''} ago`;
  } else if (diffInDays > 0) {
    formattedText = `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
  } else if (diffInHours > 0) {
    formattedText = `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
  } else if (diffInMinutes > 0) {
    formattedText = `${diffInMinutes} minute${
      diffInMinutes > 1 ? 's' : ''
    } ago`;
  } else if (diffInSeconds > 0) {
    formattedText = `${diffInSeconds} second${
      diffInSeconds > 1 ? 's' : ''
    } ago`;
  } else {
    formattedText = `Just now`;
  }

  return {
    years: diffInYears,
    days: diffInDays,
    hours: diffInHours,
    minutes: diffInMinutes,
    seconds: diffInSeconds,
    text: formattedText,
  };
};
